import VueRouter from "vue-router";

const component = module => module.default || module;

let routes = [
  {
    path: '/profile',
    component: component(require('./components/common/RouterVue')),
    redirect: {name: 'portfolio.collection.create'},
    children: [
      {
        path: 'collection',
        component: component(require('./components/illustrator/portfolio/image-set/RouterVue')),
        redirect: {name: 'portfolio.collection.create'},
        children: [
          {
            path: ':id/edit',
            component: component(require('./components/illustrator/portfolio/image-set/Edit')),
            name: 'portfolio.collection.edit',
            props: true,
          },
          {
            path: ':id/add-illustrations',
            component: component(require('./components/illustrator/portfolio/image-set/AddImages')),
            name: 'portfolio.collection.add-images',
            props: true,
          },
          {
            path: ':id/edit-illustrations',
            component: component(require('./components/illustrator/portfolio/image-set/EditImages')),
            name: 'portfolio.collection.edit-images',
            props: true,
          },
          {
            path: 'add',
            component: component(require('./components/illustrator/portfolio/image-set/Create')),
            name: 'portfolio.collection.create',
          },
        ],
      },

      {
        path: 'illustrations/add/multiple',
        component: component(require('./components/illustrator/portfolio/image/AddBulk')),
        name: 'portfolio.image.add-multiple',
      },
      {
        path: 'illustration',
        component: component(require('./components/illustrator/portfolio/image-set/RouterVue')),
        redirect: {name: 'portfolio.image.add'},
        children: [
          {
            path: 'add',
            component: component(require('./components/illustrator/portfolio/image/Add')),
            name: 'portfolio.image.add',
          },
          {
            path: ':id/edit',
            component: component(require('./components/illustrator/portfolio/image/Edit')),
            name: 'portfolio.image.edit',
            props: true,
          },
        ],
      }
    ],
  },
  {
    path: '*',
    component: component(require('./components/NotFoundComponent')),
    meta: {title: 'Not Found'},
  }
];

export default new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',

  routes,
});
